import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthProvider';

const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <span className="animate-spin h-8 w-8 border-2 border-white border-t-transparent rounded-full"></span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  const isAdmin = user.email === 'nuviosites@gmail.com';
  return isAdmin ? <>{children}</> : <Navigate to="/dashboard" />;
};

export default AdminRoute;